import { makeStateKey } from '@angular/platform-browser';
import { LOCALE_ID_COOKIE } from './shared/constants';

export const localeIdStateKey = makeStateKey<string>(LOCALE_ID_COOKIE);
